import React from 'react';
import { trackAddToCart } from '../lib/metaPixel';
export function Footer() {
  return <footer className="w-full bg-botanic py-16 px-6 text-center pb-32" data-id="element-44">
      <div className="max-w-[1200px] mx-auto flex flex-col items-center" data-id="element-45">
        <div className="bg-ivory rounded-2xl px-8 py-6 mb-8 shadow-lg" data-id="element-46">
          <img src="https://cdn.magicpatterns.com/uploads/xzSfErW4tmDV1CbfJTAW59/LogoLegadoSalud.png" alt="Legado Salud Logo" className="h-24 object-contain" data-id="element-47" />
        </div>

        <p className="font-serif text-2xl md:text-3xl text-gold mb-10" data-id="element-48">
          "Tu mejor descanso empieza esta noche."
        </p>

        <a href="https://www.legadosalud.com/cart/42654220582997:1" onClick={trackAddToCart} className="inline-block bg-gold text-white font-bold text-lg px-8 py-4 rounded-xl shadow-lg shadow-gold/20 hover:shadow-gold/40 transition-all mb-12" data-id="element-49">
          COMENZAR AHORA — $9.99 USD →
        </a>

        <div className="flex flex-wrap justify-center gap-6 text-ivory/60 text-sm mb-6" data-id="element-50">
          <a href="#" className="hover:text-gold transition-colors" data-id="element-51">
            Política de Privacidad
          </a>
          <span data-id="element-52">·</span>
          <a href="#" className="hover:text-gold transition-colors" data-id="element-53">
            Términos
          </a>
          <span data-id="element-54">·</span>
          <a href="#" className="hover:text-gold transition-colors" data-id="element-55">
            Contacto
          </a>
        </div>

        <p className="text-ivory/40 text-sm" data-id="element-56">
          © 2025 Legado Salud. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}